import { StaticJsonRpcProvider } from '@ethersproject/providers'

export const RPG_PROD_NODE =
  process.env.NEXT_PUBLIC_NODE_PRODUCTION || 'https://mainnet.rangersprotocol.com/api/jsonrpc'
// export const RPG_PROD_NODE = process.env.NEXT_PUBLIC_NODE_PRODUCTION || 'http://ponytaswap.rangersprotocol.com/api/jsonrpc'

export const rpgRpcProvider = new StaticJsonRpcProvider(RPG_PROD_NODE)

export default null
